import Swiper, {Autoplay, HashNavigation, Navigation, Pagination} from 'swiper';
import SimpleBar from "simplebar";
import Cookies from 'js-cookie';

const theme = {
    light: 'light',
    dark: 'dark'
}

export default {

    init() {
        // JavaScript to be fired on all pages
        console.log('common');
        this.apparence = theme.light;

        this.initApparence();
        this.initHeroSlider();
        this.initAbout();
        this.initFilter();
        this.initTestamonies();
        this.initEngagements();
        this.initExpertises();
        this.initExpertisesMobile();
        this.initKeysFigures();
        this.initArticleSticky();
        this.initRelatedPosts();
        this.initPersonnes();
        this.initDocuments();
        this.initPliable();
        this.initContentMediaSlider();
        this.initTimelineSlider();
        this.initCarouselIcons();
        this.initSimpleBarScroll();
        this.initScrollTop();
        this.initSearch();
        this.loadYoutubeVideo();
        this.initHighlightedPostsSlider();
        this.initTouchSpinNumberInput();
        this.initCheckBoxAndRadioInputs();
        this.initFileInputs();
        this.handleCf7MultistepSubmitBtn();
        this.changeCheckFormMultistep();
        this.handleSelectWithEuroSign();
        this.initEventTypeLegaux();

        const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
        /*if ( prefersDarkScheme.matches ) {
            $('body').addClass('dark-theme');
        } else {
            $('body').removeClass('dark-theme');
        }*/
    },

    initSearch() {
        $('.btn-search').on('click', (e) => {
            e.stopPropagation();
            $('body').toggleClass('open-search-box');
        })

        $('.search-form').on('click', (e) => {
            e.stopPropagation();
        })
    },

    /*
    * init Apparence
     */

    initApparence() {
        let _apparence = Cookies.get('apparence');
        console.log('apparence', _apparence);

        if (!_apparence) {
            _apparence = this.apparence;
            Cookies.set('apparence', _apparence, {expires: 365});
        } else {
            this.apparence = _apparence;
        }

        // console.log('this.apparence', this.apparence);

        if (this.apparence == theme.dark) {
            $('body').addClass('dark-theme');
            console.log('this.apparence', this.apparence);
        }

        $('.btn-apparence').on('click', () => {
            if (this.apparence == theme.dark) {
                $('body').removeClass('dark-theme');
                this.apparence = theme.light;
            } else {
                $('body').addClass('dark-theme');
                this.apparence = theme.dark;
            }

            Cookies.set('apparence', this.apparence, {expires: 365});
        });
    },

    /*
    * init menu
     */
    initMenu() {
        $('.btn-menu-burger').on('click', () => {
            $('body')
                .removeClass('menu-mobile-close')
                .addClass('menu-mobile-open');
        });

        $('.btn-menu-close, .overlay').on('click', () => {
            this.closeMenuMobile();
        });

        /*$('.btn-menu-close').on ('click', () => {
            this.closeMenuMobile();
        });*/
    },

    /*
    * close menu mobile
     */
    closeMenuMobile() {
        $('body')
            .removeClass('menu-mobile-open')
            .addClass('menu-mobile-close');
    },

    /*
    * Slider Hero
     */
    initHeroSlider() {
        if ($('.slider-hero').length > 0 && $('.slider-hero .swiper-slide').length > 1) {
            const swiperHero = new Swiper('.slider-hero', {
                // If we need pagination
                loop: true,
                autoplay: {
                    delay: 2250
                },
                rewind: false,
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    init: function (swiper) {
                        const firstItemDuplicated = swiper.slides.filter(slide => $(slide).data('swiper-slide-index') === 0);
                        if (firstItemDuplicated.length > 1) {
                            for (let i = 1; i < firstItemDuplicated.length; i++) {
                                const sliderItem = firstItemDuplicated[i];
                                const sliderTitle = $(sliderItem).find('h1');
                                const sliderTitleContent = sliderTitle.text();

                                sliderTitle.replaceWith(`<p class="slider-title">${sliderTitleContent}</p>`)
                            }
                        }
                    },
                },

                modules: [Navigation, Pagination, Autoplay]
            });
        }
    },

    initAbout() {
        $('.read-more .btn-more a').on('click', () => {
            $('.strate-about .read-more').toggleClass('open');
            return false;
        })
    },

    initPliable() {
        if ($('.content-pliable').length > 0) {
            $('.content-pliable-header [class*="fa-circle"]').on('click', (e) => {
                console.log(e);
                const $this = $(e.currentTarget);
                const $wrapper = $this.parents('.content-pliable').eq(0);

                $wrapper.toggleClass('expand');
            })
        }
    },

    initFilter() {
        const swiperFilter = new Swiper('.swiper-filter', {
            spaceBetween: 150,
            hashNavigation: {
                watchState: true,
                replaceState: false
            },
            // Navigation arrows
            navigation: {
                nextEl: '.filter-slider .swiper-button-next',
                prevEl: '.filter-slider .swiper-button-prev',
            },
            modules: [Navigation, HashNavigation],

            on: {
                slideChangeTransitionEnd: () => {
                    const titre = $('.swiper-filter .swiper-slide-active .name').text();
                    const linkPage = $('.swiper-filter .swiper-slide-active .name').attr('data-link-page');
                    $('#reseau').get(0).scrollIntoView({behavior: 'smooth'});
                    // console.log(linkPage);
                    if (linkPage == '') {
                        $('a.btn-pays').css('visibility', 'hidden');
                    } else {
                        $('a.btn-pays').css('visibility', 'visible');
                        $('a.btn-pays').attr('href', linkPage);
                    }
                    $('input[name="pays-filter"]').val(titre);
                }
            }
        })

        $('input[name="pays-filter"]').on('keyup', (e) => {
            const $searchImput = $(e.currentTarget);
            var val = $searchImput.val().toLowerCase();
            val = val.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            $('.carte .filter-dropdown').show('100');

            $('.filter-dropdown ul li').each((i, e) => {
                const $item = $(e);
                let found = $item.data('search').toLowerCase().match(val);
                if (found) {
                    $item.show(100);
                } else {
                    $item.hide();
                }
            })
        });

        if ($('.filter-slider .btn-pays').length > 0) {
            $('a.btn-pays').attr('href', $('.swiper-filter .swiper-slide:eq(0) .name').attr('data-link-page'));
        }

        $('.filter-form').each((index, elem) => {
            $('.form-caret, input[name$="filter"]', elem).on('click', (e) => {
                const $dropdown = $('.filter-dropdown', elem);
                $('.filter-dropdown').not($dropdown).hide('50');
                e.stopPropagation();
                console.log($dropdown.is(":visible"));
                if ($dropdown.is(":visible")) {
                    $dropdown.hide('50');
                } else {
                    $dropdown.show('100');
                }
            });
        })
    },

    hideFilter() {
        setTimeout(() => {
            $('.filter-dropdown').hide('50');
        }, 100);
    },

    initKeysFigures() {
        if ($('.strate-keys-figures').length > 0) {
            let sliderOptionsFill = {
                spaceBetween: 50,
                slidesPerView: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Pagination],
            }

            const swiperKeyFill = new Swiper('.strate-keys-figures.type-uni .swiper-key', sliderOptionsFill);

            let sliderOptionsCard = {
                spaceBetween: 16,
                slidesPerView: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                    1530: {
                        slidesPerView: 4,
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Pagination],
            }

            const swiperKeyCard = new Swiper('.strate-keys-figures.type-box .swiper-key', sliderOptionsCard);
        }

        if ($('.strate-content-slider').length > 0) {
            const swiperKey = new Swiper('.strate-content-slider .swiper-key', {
                spaceBetween: 300,
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Pagination],
            });
        }

        if ($('.strate-keys-groupe').length > 0) {
            const swiperKey = new Swiper('.strate-keys-groupe .swiper-key', {
                spaceBetween: 150,
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                modules: [Pagination],
            });
        }
    },

    initDocuments() {
        if ($('.strate-documents').length > 0) {
            $('.btn', '.strate-documents').on('click', (e) => {
                $('.document-item.hide').removeClass('hide');
                $('.btn-xrapper', '.strate-documents').hide();

                return false;
            })
        }
    },

    initPersonnes() {
        let sliderOptions = {
            centeredSlides: false,
            spaceBetween: 50,
            initialSlide: 1,
            breakpoints: {
                1024: {
                    centeredSlides: true,
                    slidesPerView: 3
                }
            },
            pagination: {
                el: '.personnes-wrapper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.personnes-wrapper .swiper-button-next',
                prevEl: '.personnes-wrapper .swiper-button-prev',
            },
            modules: [Navigation, Pagination],
        }

        const swiperPersonnes = new Swiper('.swiper-personnes', sliderOptions)
    },

    initTestamonies() {
        let sliderOptions = {
            centeredSlides: true,
            pagination: {
                el: '.temoignage-wrapper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.temoignage-wrapper .swiper-button-next',
                prevEl: '.temoignage-wrapper .swiper-button-prev',
            },
            modules: [Navigation, Pagination],
        }

        if ($('.swiper-temoignage').attr('data-show') == 3) {
            Object.assign(sliderOptions, {
                initialSlide: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 1.2
                    },
                    1024: {
                        slidesPerView: 2.3
                    },
                    1200: {
                        slidesPerView: 3
                    }
                }
            })
        }
        const swiperFilter = new Swiper('.swiper-temoignage', sliderOptions)
    },

    initArticleSticky() {
        const swiperArticleSticky = new Swiper('.swiper-actus-sticky', {
            centeredSlides: true,
            spaceBetween: 100,

            pagination: {
                el: '.actus-wrapper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.actus-wrapper .swiper-button-next',
                prevEl: '.actus-wrapper .swiper-button-prev',
            },
            modules: [Navigation, Pagination],
        })
    },

    initEngagements() {
        const swiperEngagement = new Swiper('.swiper-engagement', {
            spaceBetween: 50,
            slidesPerView: 1,
            breakpoints: {
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 50
                }
            },
            pagination: {
                el: '.swiper-engagement .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.engagements-wrapper .swiper-button-next',
                prevEl: '.engagements-wrapper .swiper-button-prev',
            },
            modules: [Navigation, Pagination],
        });

        /*$('a[data-target]').on ('click', (e) => {
            const $link = $(e.currentTarget);
            const $content = $('[data-name="' + $link.attr('data-target') + '"]');
            const $popin = $('.popin-engagement');

            $('body').addClass('open-popin-engagement');
            $('.popin-content', $popin).html( $content.html() );
            this.simpleBar = new SimpleBar($('.popin-content', $popin)[0], {
                autoHide: false
            });
        });*/
    },

    initExpertises() {
        // init key figure slider
        const $tabConents = $('.expertises-desktop .tab-content');
        const $tabNavs = $('.expertises-desktop .tab-navitem');
        const swiperKey = new Swiper('.strate-expertises .swiper-key', {
            spaceBetween: 100,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            modules: [Navigation, Pagination],
        });

        // initTab
        // console.log ( $('.swiper-key') );
        $tabConents.slice(1).removeClass('tab-content-active');
        $tabNavs.eq(0).addClass('tab-navitem-active');

        $('a', $tabNavs).on('click', (e) => {
            const $link = $(e.currentTarget);

            // Active tabs
            $tabNavs.removeClass('tab-navitem-active');
            $link.parents('.tab-navitem').eq(0).addClass('tab-navitem-active');

            // show tab oontent
            $tabConents.removeClass('tab-content-active');
            $('[data-tab-content="' + $link.attr('data-tab-target') + '"]').addClass('tab-content-active');

            return false;
        });
    },

    initExpertisesMobile() {
        $('a', '.expertise-name').on('click', (e) => {
            const $link = $(e.currentTarget);
            const $content = $('.expertise-item-content', $link.parents('.expertise-name').eq(0));
            const $popin = $('.popin-engagement');
            $popin.addClass('popin-expertise')

            $('body').addClass('open-popin-engagement');
            $('.popin-content', $popin).append($content.clone(true));

            const swiperKeyM = new Swiper('.popin .swiper-key', {
                spaceBetween: 100,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                modules: [Navigation, Pagination],
            });

            this.simpleBar = new SimpleBar($('.popin-content', $popin)[0], {
                autoHide: false
            });


        });
    },

    initRelatedPosts() {
        const swiperRelatedPosts = new Swiper('.swiper-related-posts', {
            spaceBetween: 50,
            slidesPerView: 1,
            breakpoints: {
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 36,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 36
                }
            },
            pagination: {
                el: '.swiper-related-posts .swiper-pagination',
                clickable: true
            },
            modules: [Pagination],
        });
    },

    scrollPageTo($target) {
        if ($target && ($($target).length > 0)) {
            $('html, body').animate({
                scrollTop: $($target).offset().top
            }, 1000);

            // this.hash($target);
        }
    },

    /*
   * Slider content media
    */
    initContentMediaSlider() {
        if ($('.swiper-content-media').length > 0 && $('.swiper-content-media .swiper-slide').length > 1) {
            const swiperMedia = new Swiper('.swiper-content-media', {
                // If we need pagination
                loop: true,
                rewind: false,
                pagination: {
                    el: '.swiper-content-media .swiper-pagination',
                    clickable: true
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-content-media .swiper-button-next',
                    prevEl: '.swiper-content-media .swiper-button-prev',
                },
                on: {
                    slideChange: function (el) {
                        $('.strate-content-video .swiper-slide').each(function () {
                            const youtubePlayer = $(this).find('iframe').get(0);
                            if (youtubePlayer) {
                                const youtubeSrc = $(youtubePlayer).attr('src')
                                if (youtubeSrc.indexOf('&enablejsapi=1') === -1) {
                                    const srcWithEnableParam = youtubeSrc + '&enablejsapi=1'
                                    $(youtubePlayer).attr('src', srcWithEnableParam)
                                }
                                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                            }
                        });
                    }
                },

                modules: [Navigation, Pagination]
            })
        }
    },

    /*
  * Slider timeline
   */
    initTimelineSlider() {
        if ($('.strate-timeline').length > 0) {
            const swiperTimeline = new Swiper('.strate-timeline .swiper-timeline', {
                slidesPerView: 1,
                centerInsufficientSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                    1200: {
                        slidesPerView: 6,
                    }
                },
                pagination: {
                    el: '.swiper-timeline .swiper-pagination',
                    clickable: true
                },
                modules: [Pagination]
            });
            this.calculateTimeLineBasis()
            $(window).resize(() => this.calculateTimeLineBasis());
        }
    },

    initCarouselIcons() {
        const carouselIcons = $('.swiper-carrousel-icones')
        if (carouselIcons.length > 0) {
            $(carouselIcons).each(function (index) {
                $(this).addClass('swiper-' + index)
                $(this).next(".swiper-pagination").addClass("pagination-" + index);
                $(this).siblings(".swiper-button-prev").addClass("btn-prev-" + index);
                $(this).siblings(".swiper-button-next").addClass("btn-next-" + index);
                const defaultOptions = {
                    loop: false,
                    centerInsufficientSlides: true,
                    slidesPerView: 1,
                    initialSlide: 1,
                    pagination: {
                        el: `.pagination-${index}`,
                        clickable: true
                    },
                    navigation: {
                        nextEl: `.btn-next-${index}`,
                        prevEl: `.btn-prev-${index}`,
                    },

                    modules: [Navigation, Pagination]
                }
                let options = {}
                if ($(`.swiper-${index} .swiper-slide`).length !== 2) {
                    options = {
                        ...defaultOptions,
                        centeredSlides: true,
                        spaceBetween: 40,
                        breakpoints: {
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 60
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 80
                            }
                        }
                    }
                } else {
                    options = {
                        ...defaultOptions,
                        spaceBetween: 10,
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                            }
                        },
                        on: {
                            init: swiper => {
                                const slides = swiper.slides
                                const swiperWrapper = swiper.wrapperEl
                                $(swiperWrapper).addClass('swiper-wrapper-uniform')
                                for (let slide of slides) {
                                    $(slide).addClass('swiper-uniform')
                                }
                            }
                        }
                    }
                }
                const swiperCarouselIcons = new Swiper(`.swiper-${index}`, options)
            })
        }
    },

    calculateTimeLineBasis() {
        const timelines = $('.strate-timeline')
        for (let timeline of timelines) {
            const timelineItems = $(timeline).find('.swiper-slide .icone-box')
            const placeholders = $(timeline).find('.swiper-slide .placeholder')
            let counter = 0;

            for (let i = 0; i < timelineItems.length; i++) {
                timelineItems[i].style.flexBasis = `0px`;
                placeholders[i].style.flexBasis = `0px`;
            }

            for (let i = 0; i < timelineItems.length; i++) {
                const singleHeight = timelineItems[i].offsetHeight;

                if (counter < singleHeight) {
                    counter = singleHeight;
                }
            }

            for (let i = 0; i < timelineItems.length; i++) {
                timelineItems[i].style.flexBasis = `${counter}px`;
                placeholders[i].style.flexBasis = `${counter}px`;
            }
        }
    },

    initSimpleBarScroll() {
        const popuPays = $('#popup-pays');
        const filterDropdown = $('.filter-dropdown');
        const categoryFilter = $('.category-filter-col');
        console.log('filterDropdown', filterDropdown);
        if (filterDropdown.length > 0) {
            if (popuPays.length > 0) {
                $(filterDropdown).css({"maxHeight": '35vh'});
            } else if (categoryFilter.length > 0) {
                $(filterDropdown).css({"maxHeight": '50vh'});
            } else {
                $(filterDropdown).css({"maxHeight": '70vh'});
            }
            $(filterDropdown).each((index, element) => {
                this.simpleBar = new SimpleBar(element, {autoHide: false});
            })
        }
    },

    initScrollTop() {
        const scrollTop = $('.scroll-top');
        if (scrollTop.length > 0) {
            scrollTop.on('click', () => {
                $("html, body").animate(
                    {scrollTop: "0"},
                    800
                );
            })
        }
    },


    initEventTypeLegaux(){



        $('#rtypephone').on('keypress', function(e) {
            const val = $(this).val();
            const code = $(this).siblings(".flag-container").find(".country-list li.active span.dial-code").text();
            var index = val.indexOf(code);
            var modified_string = val.slice(0, index + code.length) + ' ' + val.slice(index + code.length).trim();
            console.log(modified_string,'string modified')
            $(this).val(modified_string)
        });



        const inputTypePerson = $('#rtype');
        const rtypenamelabel = $('#rtypenamelabel');
        const rtypelastnamelabel = $('#rtypelastnamelabel');
        const rtypeadresslabel = $('#rtypeadresslabel');
        const rtypeemaillabel = $('#rtypeemaillabel');
        const rtypephonelabel = $('#rtypephonelabel');
        const amountRequiredInEuro = $("input[name=AmountRequiredInEuro]")
        const amountRequiredInEuroL = $("input[name=AmountRequiredInEuroL]")



        if(amountRequiredInEuro){
            amountRequiredInEuro.css('background-color','#dedcdc')
        }
        if(amountRequiredInEuroL){
            amountRequiredInEuroL.css('background-color','#dedcdc')
        }

        $(inputTypePerson).on('change', function () {

            if (inputTypePerson.val() === 'President' || inputTypePerson.val() === 'Président') {

                rtypenamelabel.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                rtypelastnamelabel.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                rtypeadresslabel.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                rtypeemaillabel.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                rtypephonelabel.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                if ($('#rtypename').val() === ' ') $('#rtypename').val('');
                if ($('#rtypelastname').val() === ' ') $('#rtypelastname').val('');
                if ($('#rtypeadress').val() === ' ') $('#rtypeadress').val('');
                if ($('#rtypeemail').val() === ' ') $('#rtypeemail').val('');
                if ($('#rtypephone').val() === ' ') $('#rtypephone').val('');


            } else {
                rtypenamelabel.text(function (index, currentText) {
                    return currentText.replace(/\*/g, '');
                });
                rtypelastnamelabel.text(function (index, currentText) {
                    return currentText.replace(/\*/g, '');
                });
                rtypeadresslabel.text(function (index, currentText) {
                    return currentText.replace(/\*/g, '');
                });
                rtypeemaillabel.text(function (index, currentText) {
                    return currentText.replace(/\*/g, '');
                });
                rtypephonelabel.text(function (index, currentText) {
                    return currentText.replace(/\*/g, '');
                });


            }
        });
        const button = $('#cf7mls-next-btn-cf7mls_step-2')
        $(button).on('click', function () {
            if (inputTypePerson.val() !== 'President' && inputTypePerson.val() !== 'Président') {
                if (!$('#rtypename').val()) $('#rtypename').val(' ');
                if (!$('#rtypelastname').val()) $('#rtypelastname').val(' ');
                if (!$('#rtypeadress').val()) $('#rtypeadress').val(' ');
                if (!$('#rtypeemail').val()) $('#rtypeemail').val(' ');
                if (!$('#rtypephone').val()) $('#rtypephone').val(' ');
            }
        });
    },


    handlePhonetext(newFieldGroup){
        const rtypephone = newFieldGroup.find('#rtypephone')
        rtypephone.on('keypress', function(e) {
            const val = $(this).val();
            const code = $(this).siblings(".flag-container").find(".country-list li.active span.dial-code").text();
            console.log(code,'--code--')
            var index = val.indexOf(code);
            var modified_string = val.slice(0, index + code.length) + ' ' + val.slice(index + code.length).trim();
            console.log(modified_string,'string modified')
            $(this).val(modified_string)
        });
    },



    addEventToTypeLegaux(newFieldGroup){
        const inputTypePerson = newFieldGroup.find('.wpcf7-select')
        const label = newFieldGroup.find('.form-label')
        const inputText = newFieldGroup.find('.wpcf7-text')
        const inputMail = newFieldGroup.find('.wpcf7-email')
        const button = $('#cf7mls-next-btn-cf7mls_step-2')

        $(inputTypePerson).on('input', function () {
            if (inputTypePerson.val() === 'President' || inputTypePerson.val() === 'Président') {
                label.text(function (index, currentText) {
                    currentText =  currentText.replace('*', '');
                    return currentText + '*';
                });
                if (newFieldGroup.find('#rtypename').val() === ' ') newFieldGroup.find('#rtypename').val('');
                if (newFieldGroup.find('#rtypelastname').val() === ' ') newFieldGroup.find('#rtypelastname').val('');
                if (newFieldGroup.find('#rtypeadress').val() === ' ') newFieldGroup.find('#rtypeadress').val('');
                if (newFieldGroup.find('#rtypeemail').val() === ' ') newFieldGroup.find('#rtypeemail').val('');
                if (newFieldGroup.find('#rtypephone').val() === ' ') newFieldGroup.find('#rtypephone').val('');

            } else {
                label.text(function (index, currentText) {
                    return currentText.replace('*', '');
                });

            }
        });

        $(button).on('click', function () {
                if (inputTypePerson.val() !== 'President' && inputTypePerson.val() !== 'Président') {
                    if (!newFieldGroup.find('#rtypename').val()) newFieldGroup.find('#rtypename').val(' ');
                    if (!newFieldGroup.find('#rtypelastname').val()) newFieldGroup.find('#rtypelastname').val(' ');
                    if (!newFieldGroup.find('#rtypeadress').val()) newFieldGroup.find('#rtypeadress').val(' ');
                    if (!newFieldGroup.find('#rtypeemail').val()) newFieldGroup.find('#rtypeemail').val(' ');
                    if (!newFieldGroup.find('#rtypephone').val()) newFieldGroup.find('#rtypephone').val(' ');

                }
        });

    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        this.initMenu();

        $('a[href^="#"]').on('click', (e) => {
            this.scrollPageTo($(e.currentTarget).attr('href'));
            this.closeMenuMobile();
        });

        $(document).on('click', () => {
            this.hideFilter();
            $('body').removeClass('open-search-box');
        });

        $('.popin-close').on('click', () => {
            $('body').removeClass('open-popin-engagement');

            if (this.simpleBar) {
                this.simpleBar.unMount();
            }
            $('.popin').removeClass('popin-expertise');
            $('.popin-content', '.popin').empty();
        });

        $('body').on('wpcf7-field-groups/added', (event) => {
            const newFieldGroup = $(event.target).closest('.wpcf7-field-group').next()
            const inputTelFields = newFieldGroup.find('.wpcf7-phonetext')


            this.addEventToTypeLegaux(newFieldGroup);
            this.handlePhonetext(newFieldGroup);
            if (inputTelFields.length) {
                inputTelFields.each((index, element) => {
                    $(element).intlTelInput({
                        autoHideDialCode: false,
                        autoPlaceholder: "off",
                        geoIpLookup: function (callback) {
                            $.get("https://ipinfo.io", function () {
                            }, "jsonp").always(function (resp) {
                                const countryCode = (resp && resp.country) ? resp.country : "";
                                callback(countryCode);
                            });
                        },
                        initialCountry: "auto",
                        hiddenInput: "full_number",
                        nationalMode: false
                    })
                })
            }

        })


    },

    loadYoutubeVideo() {
        $(window).on('load', () => {
            const videoWrapper = $(".video-wrapper");
            videoWrapper.each((id, thumbnail) => {
                $(thumbnail).on("click", () => {
                    const videoUrl = $(thumbnail).data("video-url");
                    $(thumbnail).html(`<iframe src="${videoUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`);
                    $(thumbnail).addClass('loaded');
                });
            });
        })
    },

    initHighlightedPostsSlider() {
        if ($('.strate-posts-highlighted-term')) {
            const sliderHighlightedPostsOptions = {
                spaceBetween: 20,
                slidesPerView: 1,
                pagination: {
                    el: '.strate-posts-highlighted-term .swiper-pagination',
                    clickable: true
                },
                modules: [Pagination],
            }
            const sliderHighlightedPosts = new Swiper('.strate-posts-highlighted-term .swiper', sliderHighlightedPostsOptions);
        }
    },

    initTouchSpinNumberInput() {
        const touchSpinNumberInputs = $('.form-touchspin-number')

        if (touchSpinNumberInputs.length) {
            touchSpinNumberInputs.each((index, element) => {
                const incrementBtn = $(element).find('.touchspin-up');
                const decrementBtn = $(element).find('.touchspin-down');
                const inputNumber = $(element).find('input[type="number"]')

                incrementBtn.click(() => {
                    inputNumber.val((!isNaN(parseInt(inputNumber.val())) ? parseInt(inputNumber.val()) : 0) + 1);
                    decrementBtn.removeClass('disabled');
                })

                decrementBtn.click(() => {
                    let value = parseInt(inputNumber.val());

                    if (value > inputNumber.attr('min')) {
                        inputNumber.val(value - 1);

                        if (parseInt(inputNumber.val()) === 0) {
                            decrementBtn.addClass('disabled')
                        }
                    }
                })
            })
        }
    },

    initCheckBoxAndRadioInputs() {
        const checkBoxAndRadioInputs = $('.wpcf7-form-control input[type="checkbox"], .wpcf7-form-control input[type="radio"]');
        if (checkBoxAndRadioInputs.length) {
            checkBoxAndRadioInputs.each((index, element) => {
                const checkboxLabel = element.parentElement
                const checkmarkSpan = document.createElement('span')

                checkmarkSpan.className = 'checkmark'
                checkboxLabel.appendChild(checkmarkSpan)
            })
        }
    },

    initFileInputs() {
        const fileInputs = $('.form-file');
        if (fileInputs.length) {
            fileInputs.each((index, element) => {
                const fileInput = $(element).find('.wpcf7-form-control.wpcf7-file')

                fileInput.on('change', () => {
                    $(element).find('.file-name').text(fileInput[0].files[0].name)
                })
            })
        }
    },

    handleCf7MultistepSubmitBtn() {
        const formSubmitWrapper = $('#form-submit-wrapper')

        if (formSubmitWrapper) {
            const formButtonBack = formSubmitWrapper.nextAll('button').first()
            formSubmitWrapper.prepend(formButtonBack)
        }
    },

    changeCheckFormMultistep() {
        const formMultistepProgress = $('.cf7mls_progress_bar')
        if (formMultistepProgress.length) {
            const formCheckIconWrapper = formMultistepProgress.find('.cf7_mls_check')

            formCheckIconWrapper.each((index, element) => {
                $(element).html(`<i>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="55" height="63" viewBox="0 0 55 63" fill="none">
                                                <g clip-path="url(#clip0_547_1884)">
                                                    <path d="M53.8454 12.9691C55.38 14.5072 55.38 17.0051 53.8454 18.5432L22.4169 50.0432C20.8823 51.5813 18.3901 51.5813 16.8555 50.0432L1.14118 34.2932C-0.393415 32.7551 -0.393415 30.2572 1.14118 28.7191C2.67578 27.1811 5.16797 27.1811 6.70257 28.7191L19.6423 41.676L48.2963 12.9691C49.8309 11.4311 52.3231 11.4311 53.8577 12.9691H53.8454Z" fill="white"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_547_1884">
                                                        <rect width="55" height="63" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </i>`)
            })
        }
    },

    handleSelectWithEuroSign() {
        const formGroupFields = $('.wpcf7-field-group')

        if (formGroupFields.length) {
            formGroupFields.each((index, element) => {
                const formGroupSelect = $(element).find('select')

                if (formGroupSelect) {
                    formGroupSelect.on('change', () => {
                        const formGroupSelectValue = formGroupSelect.val()

                        if (formGroupSelectValue.indexOf('euros') === -1) {
                            $(element).find('.fa-euro-sign')?.css('display', 'none')
                        } else {
                            $(element).find('.fa-euro-sign')?.css('display', 'block')
                        }
                    })
                }
            })
        }
    }
};
